import { motion } from "framer-motion";
import { Scissors } from "lucide-react";

const links = [
  { label: "Keunggulan", href: "#capcut-fitur" },
  { label: "Harga", href: "#capcut-harga" },
  { label: "Testimoni", href: "#capcut-testimoni" },
  { label: "FAQ", href: "#capcut-faq" },
];

export const CapCutNavbar = () => (
  <motion.header
    initial={{ y: -60, opacity: 0 }}
    animate={{ y: 0, opacity: 1 }}
    transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
    className="fixed top-[3px] left-0 right-0 z-50 backdrop-blur-xl bg-white/80 border-b border-slate-200/50"
  >
    <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 h-16 flex items-center justify-between">
      <a href="/capcut" data-testid="capcut-navbar-logo" className="flex items-center gap-2.5">
        <span className="w-9 h-9 rounded-xl bg-slate-900 flex items-center justify-center">
          <Scissors className="w-4.5 h-4.5 w-4 h-4 text-white" strokeWidth={2.5} />
        </span>
        <span className="font-capcut-heading font-black text-sm sm:text-base tracking-[0.08em] uppercase text-slate-900">
          Hotaro <span className="text-blue-600">Digital Store</span>
        </span>
      </a>
      <nav className="hidden md:flex items-center gap-8" data-testid="capcut-navbar-menu">
        {links.map((link) => (
          <button
            key={link.href}
            onClick={() => document.querySelector(link.href)?.scrollIntoView({ behavior: "smooth" })}
            data-testid={`capcut-nav-${link.href.slice(1)}`}
            className="text-sm font-semibold text-slate-700 hover:text-blue-600 transition-colors"
          >
            {link.label}
          </button>
        ))}
      </nav>
    </div>
  </motion.header>
);
